<template>

<div class="demo-tabs-style2">
  <Tabs
      type="card"
      :animated="false"
      @on-click="tabsClick"
      v-model="tabValue"
    >
    <TabPane :label="'绩效评估'"  name="performance"
     ></TabPane>
     <TabPane :label="'潜能评估'" name="potential"
     ></TabPane>
    </Tabs>
      <performance v-if="tabValue == 'performance'"/>
      <potential v-if="tabValue == 'potential'"/>
</div>

</template>

<script>
import performance from "./AchReportHRComponents/performance.vue";
import potential from "./AchReportHRComponents/potential.vue";
export default {
components: {
    performance,
    potential,
},
data() {
  return {
    tabValue:'performance',
  };
},

mounted () {},

methods: {
  tabsClick(val) {
    this.tabValue = val
  }
},
}
</script>

<style  lang='scss'>
.demo-tabs-style2 > .ivu-tabs.ivu-tabs-card > .ivu-tabs-bar .ivu-tabs-tab {
  border-radius: 0;
  background: #459846;
  color: #ffffff;
}
.demo-tabs-style2
  > .ivu-tabs.ivu-tabs-card
  > .ivu-tabs-bar
  .ivu-tabs-tab-active {
  /* border-top: 1px solid #ffffff; */
  background: #ffffff;
  border-top: 1px solid #459846 !important;
  border-left: 1px solid #459846 !important;
  border-right: 1px solid #459846 !important;
  color: #333333;
}
</style>


// WEBPACK FOOTER //
// src/components/process/performanceManagement/components/AchReportHR.vue